import { requestMembership } from '@lumapps/communities/api';
import { Dispatch } from '@lumapps/redux/types';

import { selectSpaceId } from './selectors';
import { actions } from './slice';

export const requestAccess = async (dispatch: Dispatch, getState: GetBaseState) => {
    const id = selectSpaceId(getState()) as string;

    dispatch(actions.requestAccessRequest());

    try {
        await requestMembership({ communityKey: id });

        dispatch(actions.requestAccessSuccess());
    } catch (error) {
        dispatch(actions.requestAccessFailure());
    }
};
